import React from "react";
import { emitUnitEvent } from "@/utils/units/unitEvents";
import { useUnitItemContext } from "@/hooks/useUnitItemContext";
import { useActivateRentalJourney } from "@/hooks/useActivateRentalJourney";

let hasRunUseEffect = false;

export const useOpenEsign = () => {
    const { unitGroup, selectedPromo } = useUnitItemContext();
    const activateRentalJourney = useActivateRentalJourney();
    const unitId = unitGroup.representative_unit.id;
    const facilityId = unitGroup.representative_unit.facility_id;
    React.useEffect(() => {
        const isEsign = window.location.href.includes("e-sign");
        if (!hasRunUseEffect && isEsign) {
            hasRunUseEffect = true;

            // Emit event to send Nimbus the id's
            emitUnitEvent(unitId, facilityId, selectedPromo, "rental");
            activateRentalJourney(unitId);
        }
    }, [activateRentalJourney, facilityId, selectedPromo, unitId]);
};
